import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import App from './App.vue'
import router from './router/index.js'
import {zh,en} from '../static/lang/en'
import { resources } from '../static/resources/resources'
import api from './api/api.js'
require("./assets/js/rem.min.js")
import VueI18n from 'vue-i18n'
import { setgoindex } from './utils/utils'
Vue.use(VueI18n)

let locale = localStorage.getItem('language') || 'zh';

const i18n = new VueI18n({
 locale,
 messages: {zh,en}
})

localStorage.setItem('language',locale);

import "./styles/global.css"

Vue.prototype.$api = api;

// 判断是否存在上一页
Vue.prototype.$setgoindex = setgoindex;

Vue.prototype.imageBase = 'https://buchtech-1301015442.cos.ap-guangzhou.myqcloud.com/'
//获取当前是手机还是电脑
let width = document.body.clientWidth;
//设置设备类型
Vue.prototype.device = width > 1200 ? 'pc' : 'mobile';

//设置资源文件
Vue.prototype.$resources = resources;

import 'swiper/dist/css/swiper.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper)　　

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js